import { FormInstance } from "antd/lib/form"
import { Moment } from "moment-timezone"
import i18n from "Shared/locales/i18n"

export const checkMinDate = (formInstance: FormInstance, value: Moment, name: string, minText = "", maxText = "") => {
    const maxDate = formInstance.getFieldValue(name)

    if (maxDate && value && value.toDate() > maxDate) {
        return Promise.reject(
            i18n.t("validation:date_before", {
                attribute: i18n.t(minText ? minText : "input:filter_form.starting_date"),
                compare: i18n.t(maxText ? maxText : "input:filter_form.starting_date"),
            })
        )
    }

    return Promise.resolve()
}

export const checkMaxDate = (formInstance: FormInstance, value: Moment, name: string, minText = "", maxText = "") => {
    const minDate = formInstance.getFieldValue(name)

    if (minDate && value && value.toDate() < minDate) {
        return Promise.reject(
            i18n.t("validation:date_after", {
                attribute: i18n.t(minText ? minText : "input:filter_form.starting_date"),
                compare: i18n.t(maxText ? maxText : "input:filter_form.starting_date"),
            })
        )
    }

    return Promise.resolve()
}

export const checkMinNumber = (formInstance: FormInstance, value: any, name: string, minText = "", maxText = "", limit: undefined | number = undefined) => {
    value = Number(value)

    if (value) {
        const maxAmount = formInstance.getFieldValue(name)
        if (value < 0) return Promise.reject(new Error(i18n.t("validation:min.number", { min: 0 })))
        if (limit && value > limit) return Promise.reject(new Error(i18n.t("validation:max.number", { max: limit })))
        if (maxAmount && value > Number(maxAmount)) {
            return Promise.reject(
                i18n.t("validation:bigger_amount", {
                    attribute: i18n.t(minText ? minText : "input:filter_form.min_amount"),
                    compare: i18n.t(maxText ? maxText : "input:filter_form.max_amount"),
                })
            )
        }
    }
    return Promise.resolve()
}

export const checkMaxNumber = (formInstance: FormInstance, value: any, name: string, minText = "", maxText = "", limit: undefined | number = undefined) => {
    value = Number(value)

    if (value) {
        const minAmount = formInstance.getFieldValue(name)
        if (value < 0) return Promise.reject(new Error(i18n.t("validation:min.number", { min: 0 })))
        if (limit && value > limit) return Promise.reject(new Error(i18n.t("validation:max.number", { max: limit })))
        if (minAmount && value < Number(minAmount)) {
            return Promise.reject(
                i18n.t("validation:smaller_amount", {
                    attribute: i18n.t(minText ? minText : "input:filter_form.min_amount"),
                    compare: i18n.t(maxText ? maxText : "input:filter_form.max_amount"),
                })
            )
        }
    }
    return Promise.resolve()
}

export const checkDueInDays = (value: any) => {
    if (value !== "undefined" && Number(value) < 0) return Promise.reject(new Error(i18n.t("validation:min.number", { min: 0 })))

    return Promise.resolve()
}
